import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TrabalhoRoutingModule } from './trabalho-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    TrabalhoRoutingModule
  ]
})
export class TrabalhoModule { }
